import { createFileRoute } from '@tanstack/react-router';

import {
  parseListRouteSearch,
  type ListRouteSearch,
} from '../../hooks/use-list-table-helpers/index.js';
import { ManufacturingOrderListPage } from '../../modules/manufacturing/manufacturing-order-list-page.js';

export const Route = createFileRoute('/manufacturing/')({
  validateSearch: (search: Record<string, unknown>): ListRouteSearch =>
    parseListRouteSearch(search),
  component: ManufacturingOrderListPage,
});
